export default "__VITE_ASSET__2496d5bc__"